export const getAttributeArray = (value: string, validatorFn: (value: string) => void, delimiter: string) => {
    if (!value) {
        return [];
    }

    const processedValue = value.trim().toLocaleLowerCase();

    const normalizedWhitespaceValue = delimiter !== ' ' ? processedValue.replace(/\s+/g, '') : processedValue;

    const normalizedDelimiterValue = normalizedWhitespaceValue.replace(new RegExp(`(${delimiter}+)`, 'g'), delimiter);

    const attrArr = normalizedDelimiterValue.split(delimiter).filter(Boolean);

    attrArr.forEach(validatorFn);

    return attrArr;
};

export const getAttributeFromArray = (list: string[], delimiter: string) =>
    Array.from(new Set(list)).join(delimiter !== ' ' ? `${delimiter} ` : delimiter);
